<mat-card>{{'mandoobStatment' | translate}}</mat-card>



<div class="container" style="padding: 25px;">

  <mat-grid-list cols="8" rowHeight="50px">
    <mat-grid-tile colspan="2">
      <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;;">
        <mat-label>{{'mandoobName' | translate}}</mat-label>
        <mat-select [(value)]="selectedMandoob">
          <mat-option *ngFor="let item of mandoobs" [value]="item.id">
            {{item.fullName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      <mat-form-field appearance="fill" class="example-form-field">
        <mat-label>{{'enterDateRange' | translate}}</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker">
          <input matStartDate placeholder="Start date" #fromDate>
          <input matEndDate placeholder="End date" #toDate>
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker>
          <mat-date-range-picker-actions>
            <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
            <button mat-raised-button color="primary" matDateRangePickerApply>{{'ok' | translate}}</button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;;">
        <mat-label>{{'category' | translate}}</mat-label>
        <mat-select [(value)]="selectedCategory">
          <mat-option value="0">None</mat-option>
          <mat-option *ngFor="let item of categories" [value]="item.id">

            {{item.arabicName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">

      <button mat-raised-button color="primary" (click)="onApply()" [disabled]="selectedMandoob == undefined"
        style="margin-left: 10px;">
        <mat-icon>search</mat-icon>
        {{'filter' | translate}}
      </button>
      <button mat-raised-button color="primary" [disabled]="reports.length == 0" (click)="Print()">
        <mat-icon>print</mat-icon>
        {{'print' | translate}}
      </button>


    </mat-grid-tile>


  </mat-grid-list>
  <hr />

  <mat-grid-list cols="6" rowHeight="50px">

    <mat-grid-tile colspan="2">
      &nbsp;
      &nbsp;
      <mat-form-field>
        <mat-label>مجموع الكلفة</mat-label>
        <input matInput [value]="getTotalCostPrice()" readonly style="color: orange;">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      &nbsp;
      &nbsp;
      <mat-form-field>
        <mat-label>مجموع البيع</mat-label>
        <input matInput [value]="getTotal()" readonly style="color: blueviolet;">
      </mat-form-field>
    </mat-grid-tile>


    <mat-grid-tile colspan="2">
      &nbsp;
      &nbsp;
      <mat-form-field>
        <mat-label>الارباح</mat-label>
        <input matInput [value]="getProfits()" readonly style="color: green;">
      </mat-form-field>
    </mat-grid-tile>

  </mat-grid-list>


  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort id="mandoobTable">

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.date | date: 'dd/MM/yyyy hh:mm a'}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef></td> -->
      </ng-container>

      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'name' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.userName}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef></td> -->
      </ng-container>

      <ng-container matColumnDef="productName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'product' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.productName}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef></td> -->
      </ng-container>

      <ng-container matColumnDef="userCatg">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'userCatg' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.userCategory}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef> {{'total' | translate}} </td> -->
      </ng-container>

      <ng-container matColumnDef="costPrice">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'costPrice' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.productCostPrice}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef> {{getTotalCostPrice()}} </td> -->
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'quantity' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.quantity}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef> {{'totalProfits' | translate}} </td> -->
      </ng-container>

      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'total' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.total}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef> {{getProfits()}} </td> -->

      </ng-container>

      <ng-container matColumnDef="phoneInfo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'phoneInfo' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.phoneInfo}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
       
        [ngStyle]="{'background-color':row.status == 2 ? 'red' : '' }"></tr>
      <!-- <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr> -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
      </tr>
    </table>

    <!-- <mat-paginator #paginator [pageSize]="pageSize" [pageIndex]="currentPage" (page)="pageChanged($event)"
      [length]="totalRowsCount" showFirstLastButtons [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>